import styled from 'styled-components'

export const Header = styled.div`
  grid-area: page-header;
  margin-top: 8px;
`
